// extracted by mini-css-extract-plugin
export default {"content":"styles_content__rRjrE","bg":"styles_bg__4zwKR"};